"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.performTransform = exports.validateTransform = void 0;
const common_1 = require("@finley-technologies/common");
const errorUtils_1 = require("./errorUtils");
const helpers_1 = require("./helpers");
const validateTransform = (transformation) => {
    const { fields } = transformation;
    // ensure that fields are not duplicated.
    const uniqueFieldNames = new Set();
    const errors = [];
    fields.forEach(({ field }) => {
        if (uniqueFieldNames.has(field)) {
            errors.push({
                type: 'metadataValidation',
                message: `Field [${field}] is duplicated`,
            });
        }
        else {
            uniqueFieldNames.add(field);
        }
    });
    // ensure all fields specify same number of pages
    // its okay for page numbers to be different for each field
    // but there must be sane number of pages specified for each field
    const uniquePageNumbers = new Set();
    fields.forEach(({ pageNumbers, field }) => {
        (0, common_1.finleyAssert)(pageNumbers, 'pageNumbers is required');
        pageNumbers.forEach((pageNumber) => {
            if (pageNumber === 0) {
                errors.push({
                    type: 'metadataValidation',
                    message: `pageNumber cannot be zero. Found 0 for field [${field}]`,
                });
            }
        });
        uniquePageNumbers.add(pageNumbers.length);
    });
    if (uniquePageNumbers.size > 1) {
        errors.push({
            type: 'metadataValidation',
            message: `all fields must specify same number of pages`,
        });
    }
    if (errors.length > 0) {
        return {
            isValid: false,
            errors,
        };
    }
    const baseFields = fields.map(({ pageNumbers: _unused1, question: _unused2, ...baseField }) => ({
        ...baseField,
    }));
    // @asset2json: this node produces json.
    // we need to think more and define tape-definition type for json files.
    // so that other tape-builder tasks can use them.
    // For now just handle this one-off node that produces json.
    // by marking it as json and return baseFields as is.
    // these are used for validation in receivableInvoice node.
    return {
        isValid: true,
        data: {
            isJson: true,
            baseFields,
            delimiter: ',',
            sanitizedFieldNames: false,
        },
    };
};
exports.validateTransform = validateTransform;
const generateAssetVerificationDocument = ({ results, transformation, }) => {
    // we expect the analyzedOutput to have same number of questions as fields
    (0, common_1.finleyAssert)(results.answers.length === transformation.fields.length, `Expected same number of [questions:${transformation.fields.length}] as [answers:${results.answers.length}]`);
    const fields = transformation.fields.map((baseFieldConfig, index) => {
        const answer = results.answers[index];
        // sanitize the answer value
        try {
            const sanitizedValue = (0, helpers_1.getSanitizedDataTapeField)(baseFieldConfig, answer.value === null ? '' : answer.value, false);
            return {
                fieldName: baseFieldConfig.field,
                raw: String(answer.value),
                error: answer.error,
                value: sanitizedValue,
                confidence: answer.confidence,
                pageNumber: answer.pageNumber,
            };
        }
        catch (err) {
            let error = `Failed to sanitize [field:${baseFieldConfig.field}] with [value:${answer.value}]. [type:${baseFieldConfig.type}].`;
            if (answer.error) {
                // include original error as well.
                error = `${error}, (textract error: ${answer.error})`;
            }
            return {
                fieldName: baseFieldConfig.field,
                raw: String(answer.value),
                error,
                value: answer.value,
                confidence: answer.confidence,
                pageNumber: answer.pageNumber,
            };
        }
    });
    return {
        fields,
    };
};
const performTransform = async ({ buffersWithExtensions, transformation, assetExtractor, }) => {
    try {
        (0, common_1.finleyAssert)(buffersWithExtensions.length === 1, 'expected 1 buffer as input');
        const params = {
            buffer: buffersWithExtensions[0].buffer,
            extension: buffersWithExtensions[0].extension ?? 'csv',
            config: transformation,
        };
        // how do we pass the artifactId here?
        const results = await assetExtractor(params);
        const document = generateAssetVerificationDocument({
            results,
            transformation,
        });
        const outputBuffer = common_1.finleyBuffer.fromString(JSON.stringify(document));
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'asset2json: ');
    }
};
exports.performTransform = performTransform;
exports.transformOperation = {
    operation: 'asset2json',
    validateTransform: exports.validateTransform,
    performTransform: exports.performTransform,
};
//# sourceMappingURL=asset2json.js.map